import React, {Fragment, useState} from "react"
import sanitizeHtml from "sanitize-html"

// styles
import {MoreInfo, EndSequence, MoreInfoWrap, OptionsWrap, OtherText, Send, SendIcon} from "../styles"

const TextAreaWithMoreEnd = ({handleSend, placeholder, currentMessage}) => {
	const [text, setText] = useState("")

	const _handleShowMore = () => {
		const {surveyId, taskId, recurring, questionIndex} = currentMessage.quickReplies
		let _id = currentMessage.quickReplies._id ? currentMessage.quickReplies._id : currentMessage._id
		let _next = currentMessage.quickReplies._next ? currentMessage.quickReplies._next : currentMessage._next

		handleSend([
			{
				replyType: "questionMoreInfo",
				moreInfo: currentMessage.moreInfo,
				questions: currentMessage.quickReplies.questions,
				surveyId,
				recurring,
				taskId,
				label: currentMessage.moreInfoLabel,
				answerLabel: currentMessage.answerLabel,
				_id,
				_next,
				questionIndex
			}
		])
	}

	const _handleEnd = () => {
		const {surveyId, taskId, recurring} = currentMessage.quickReplies
		let _id = currentMessage._id
		let _next = currentMessage._next

		handleSend([
			{
				replyType: "questionEnd",
				label: currentMessage.endLabel,
				_id,
				_next
			}
		])
	}

	const _handleSubmit = () => {
		const {questionIndex, optionType, surveyId, taskId, recurring, _id, questions} = currentMessage.quickReplies

		const {replyType, moreInfo, triggerResponse} = currentMessage
		const _next = currentMessage.quickReplies._next ? currentMessage.quickReplies._next : currentMessage._next

		const response = {
			_id: Math.random(),
			_next: _next,
			optionType: optionType,
			moreInfo: moreInfo,
			triggerResponse: triggerResponse,
			surveyId,
			label: sanitizeHtml(text),
			taskId,
			recurring,
			replyType: replyType,
			questionIndex: questionIndex,
			questions: questions
		}

		handleSend([response])
	}

	return (
		<Fragment>
			<OptionsWrap>
				<OtherText
					placeholder={currentMessage.answerLabel}
					value={text}
					onChange={e => setText(sanitizeHtml(e.target.value))}
				/>
				<MoreInfoWrap>
					<MoreInfo onClick={_handleShowMore}>{currentMessage.moreInfoLabel}</MoreInfo>
					<EndSequence onClick={_handleEnd}>{currentMessage.endLabel}</EndSequence>
				</MoreInfoWrap>
			</OptionsWrap>

			<Send onClick={_handleSubmit} data-testid='send-button'>
				<SendIcon src={require("assets/images/icons/svg/send.svg")} alt='send' />
			</Send>
		</Fragment>
	)
}

export default TextAreaWithMoreEnd
